import {
  DropDownList as KendoDropDownList,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
import * as React from "react";
import { DropDownListType } from "../../Project/EditProject/RightSide/LtlTab/LtlTabTable/RouteCell/DropDownListType";

interface Props<T> {
  label: string;
  list: Array<DropDownListType<T>>;
  value: T | undefined;
  onChange: (value: T) => void;
  disabled: boolean;
}

export function DropDownList<T>({ label, list, value, onChange, disabled }: Props<T>) {
  const text = list.find((x) => x.value === value)?.text;

  return (
    <>
      <span>{label}</span>
      <KendoDropDownList
        data={list}
        textField="text"
        dataItemKey="value"
        value={{
          text,
          value,
        }}
        onChange={(e: DropDownListChangeEvent) => onChange(e.value?.value)}
        disabled={disabled}
      />
    </>
  );
}
